import { useEffect, useRef, useState } from "react";
import { AssemblyItemsViewModel } from "../../../viewmodels/setup/assemblyItems/AssemblyItemsViewModel";
import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";
import { withRouter } from "../../../shared/utility";
import SlideOver from "../../../components/slideOver/SlideOver";
import {
  SetupActions,
  SetupPage,
  SetupTable,
  SetupTd,
} from "../../../components/setup/SetupPage";
import AuditActionLink from "../../../components/audit/AuditActionLink";
import { auditHistoriesSetupAction } from "../../../components/audit/auditEntityConfig";
import FilterDropdown from "../../../components/filterDropdown/FilterDropdown";

function AssemblyItems(props) {
  const { addSnackbar, logout } = props;
  const [initialLoading, setInitialLoading] = useState(true);
  const {
    deleteAssemblyItem,
    openAddAssemblyItemSlideOver,
    getAllergensForDropdown,
    getAssemblyItems,
    getCertifiedByOptionsForDropdown,
    getClaimsForDropdown,
    getManufacturersForDropdown,
    getMyIngredientsOptionsForDropdown,
    getPreservativesForDropdown,
    getProductTypes,
    getTaxRatesForDropdown,
    loading,
    assemblyItems,
    setSlideOver,
    slideOver,
    fetchAssemblyItemDetails,
    getUnitOfMeasuresForDropdown,
    getCountryOptionsForDropdown,
    filters,
    filterComponents,
    resetFilters,
    showFilters,
    setShowFilters,
  } = AssemblyItemsViewModel(logout, addSnackbar);

  var currentPage = 1;
  useEffect(() => {
    Promise.all([
      getAllergensForDropdown(),
      getCountryOptionsForDropdown(),
      getAssemblyItems(null, currentPage, filters),
      getCertifiedByOptionsForDropdown(),
      getClaimsForDropdown(),
      getManufacturersForDropdown(),
      getPreservativesForDropdown(),
      getProductTypes(),
      getUnitOfMeasuresForDropdown(),
      getMyIngredientsOptionsForDropdown(),
      getTaxRatesForDropdown(),
    ]).finally(() => setInitialLoading(false));
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);
  const searchRef = useRef();

  const handleSearch = () => {
    currentPage = 1;
    setFirst(1);
    getAssemblyItems(searchRef.current.value, currentPage, filters);
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getAssemblyItems(searchRef.current.value, currentPage, filters);
  };

  return (
    <div>
      <SetupPage
        title="Supplier Items"
        description="Manage supplier item records, supplier PLUs, and the item details used in receiving and traceability."
        searchPlaceholder="Search by supplier item"
        searchRef={searchRef}
        onSearch={handleSearch}
        actions={[
          {
            label: "Add Item",
            onClick: openAddAssemblyItemSlideOver,
            disabled: initialLoading,
          },
          auditHistoriesSetupAction("assembly-item"),
        ]}
        toolbarExtra={
          <FilterDropdown
            actionCall={() => {
              currentPage = 1;
              setFirst(1);
              getAssemblyItems(searchRef.current.value, currentPage, filters);
            }}
            activeFilterCount={filters.manufacturer ? 1 : 0}
            filterComponents={filterComponents}
            resetFilters={() => {
              setFirst(1);
              resetFilters(searchRef.current.value);
            }}
            showFilters={showFilters}
            setShowFilters={setShowFilters}
          />
        }
        loading={loading || initialLoading}
        tableColumns={["Item", "Supplier", "Supplier PLU"]}
        totalRecords={assemblyItems.total}
        first={first}
        rows={rows}
        onPageChange={handlePagination}
      >
        <SetupTable
          columns={["Item", "Supplier", "Supplier PLU"]}
          emptyText="No supplier items found."
        >
          {assemblyItems.data?.map((assemblyItem, index) => (
            <tr
              key={assemblyItem.id}
              className="transition hover:bg-[#F6F8FB]/80"
            >
              <SetupTd>
                <div>{assemblyItem.product_name}</div>
              </SetupTd>
              <SetupTd muted={true}>{assemblyItem.manufacturer}</SetupTd>
              <SetupTd muted={true}>{assemblyItem.manufacturer_plu}</SetupTd>
              <SetupActions>
                <button
                  type="button"
                  onClick={() => fetchAssemblyItemDetails(assemblyItem, index)}
                  className="inline-flex min-w-[68px] justify-center rounded-lg border border-[#E2E8F0] bg-white px-3 py-1.5 text-sm font-semibold text-[#0F172A] shadow-sm transition hover:border-[#2563EB] hover:bg-[#EFF6FF] hover:text-[#2563EB]"
                >
                  Edit
                </button>
                <AuditActionLink
                  slug="assembly-item"
                  id={assemblyItem.id}
                  name={
                    assemblyItem.product_name || assemblyItem.product_code || ""
                  }
                  className="ml-2"
                />
                <button
                  type="button"
                  onClick={() => deleteAssemblyItem(assemblyItem.id, index)}
                  className="ml-2 inline-flex min-w-[68px] justify-center rounded-lg border border-[#FECACA] bg-white px-3 py-1.5 text-sm font-semibold text-[#DC2626] shadow-sm transition hover:border-[#FCA5A5] hover:bg-[#FEF2F2]"
                >
                  Delete
                </button>
              </SetupActions>
            </tr>
          ))}
        </SetupTable>
      </SetupPage>
      <SlideOver
        childComponent={slideOver.childComponent}
        customClass="max-w-xl"
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AssemblyItems),
);
